module.exports = __webpack_public_path__ + "img/BG-dropdown.15830901.png";